/**
 * NoValueInput Component
 *
 * Placeholder input for operators that don't require values.
 * Used for operators: IS_NULL, IS_NOT_NULL
 */

import { Input } from 'antd'

export function NoValueInput() {
  return (
    <Input
      value="(no value needed)"
      disabled
      style={{ width: '100%', fontStyle: 'italic' }}
    />
  )
}
